import React from "react";
import { LivingExpenseCalculated } from "../types";
import { COLORS } from "../constants";
import { formatValue } from "../hook/API";

/* =======================
   PROPS
======================= */

type Props = {
  data?: LivingExpenseCalculated;
};

/* =======================
   FIELD CONFIG
======================= */

type FieldConfig = {
  label: string;
  key: keyof LivingExpenseCalculated;
};

const LIVING_EXPENSE_FIELDS: FieldConfig[] = [
  { label: "Bills", key: "Bills" },
  { label: "Education", key: "Education" },
  { label: "Food & Beverage", key: "FoodBeverage" },
  { label: "Health Care", key: "HealthCare" },
  { label: "Transportation", key: "Transportation" },
];

/* =======================
   COMPONENT
======================= */

const SimahLivingExpenseView: React.FC<Props> = ({ data }) => {
 

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <table className="table text-left table-border spaced-table">
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>

        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {LIVING_EXPENSE_FIELDS.map(({ label, key }) => (
            <tr key={key}>
              <td>{label}</td>
              <td>{formatValue(data?.[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimahLivingExpenseView;
